import { render, staticRenderFns } from "./BsAppbar.vue?vue&type=template&id=343acfe8&"
import script from "./BsAppbar.vue?vue&type=script&lang=js&"
export * from "./BsAppbar.vue?vue&type=script&lang=js&"
import style0 from "./BsAppbar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports